// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/blocks/list-widget.scss
// module id = 1070
// module chunks = 65